exports.key = 'coupon'

// 设置全局变量
const varsPlugin = {
  install(Vue) {
    // 活动key
    Vue.prototype.$key = exports.key
    // 环境变量
    Vue.prototype.$env = process.env.VUE_APP_ENV
    // 不同环境的接口
    const baseURL = {}
    baseURL.cat = `https://${window.location.host}`
    if (process.env.VUE_APP_ENV === 'prod') {
      baseURL.api = 'https://api.pangku.com'
      baseURL.merchant = 'https://merchant.pangku.com'
    } else {
      baseURL.api = 'https://tapi.pangku.com'
      baseURL.merchant = 'https://prem.pangku.com'
    }
    Vue.prototype.$baseURL = baseURL
  }
}

exports.vars = varsPlugin

// 分享文案，图片上传到七牛https://pangku.com/upload/qiniu
// link填cat.pangku.com，自动判断环境
exports.shareData = {
  title: '***',
  desc: '***',
  link: 'https://cat.pangku.com/dist/coupon/index.html',
  imgUrl: '***'
}

// 重新运行才能生效
// 地址相对vue.config.js
exports.pages = {
  paycoupon: {
    template: './src/coupon/base/template.html',
    title: '',
    entry: './src/coupon/paycoupon/paycoupon.js',
    filename: 'paycoupon.html',
    chunks: ['chunk-vendors', 'chunk-common', 'paycoupon']
  }
}

// 前端、后端和设计
exports.author = {
  frontend: 'dengweiyang',
  backend: 'zhouliping',
  designer: 'maiqiumin'
}
